import { Container } from '@ui/components/Container'
import clsx from 'clsx'

type Props = {
  className?: string
  children?: React.ReactNode
}

export const MainBlockAboutEmpowering = ({ className, children }: Props) => (
  <div className={clsx('bg-white pb-16 pt-20', className)}>
    <Container>
      <div className="flex flex-col items-center gap-12">
        <h2 className="font-display text-4xl text-center leading-tight tracking-tight text-[#0a2d4a] md:text-5xl">
          Empowering You to<br />Take Control of Your Finances
        </h2>
        <div className="flex flex-col gap-8 mb-12 max-w-5xl">
          <p className="body-2">
            At ATM.com, we believe financial well-being should be accessible to
            everyone. We understand that unexpected expenses, limited access to
            traditional financial tools, and the desire to earn extra income are
            common challenges. That's why we've built an all-in-one finance app
            that empowers you to earn extra cash, budget wisely, and access
            funds when you need them most.
          </p>
          <p className="body-2">
            Committed to transparency and fairness, we offer innovative
            solutions without credit checks or hidden fees. Our platform puts
            you in control of your financial future, providing budgeting
            insights, convenient cash advances, and opportunities to boost your
            income through rewards and cashback offers. Together, we're building
            a more inclusive financial landscape where financial peace of mind
            is a reality for all.
          </p>
        </div>
      </div>
    </Container>
  </div>
)
